import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import LandingView from "@/components/landing/LandingView";

const KEYS = ["gclid", "gbraid", "wbraid", "matchtype", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

const captureParams = (slug) => {
  const key = `am_params_${slug}`;
  const stored = JSON.parse(sessionStorage.getItem(key) || "{}");
  const qs = new URLSearchParams(window.location.search);
  KEYS.forEach((k) => { if (qs.get(k)) stored[k] = qs.get(k); });
  sessionStorage.setItem(key, JSON.stringify(stored));
  return stored;
};

const loadGtag = (awId) => {
  if (!awId || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${awId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", awId);
};

const fireConversion = (t, label) => {
  if (t?.aw_id && label && window.gtag) window.gtag("event", "conversion", { send_to: `${t.aw_id}/${label}` });
};

export default function PublicLanding() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);
  const [params, setParams] = useState({});

  useEffect(() => {
    setParams(captureParams(slug));
    axios.get(`${API}/public/lp/${slug}`).then((r) => {
      setData(r.data);
      document.title = r.data.page.content?.meta_title || r.data.page.title;
      loadGtag(r.data.tracking?.aw_id);
    }).catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <div className="grid min-h-screen place-items-center bg-white text-slate-600" data-testid="lp-not-found">This page isn't available.</div>;
  if (!data) return <div className="min-h-screen bg-white" />;

  const onLead = async (form) => {
    await axios.post(`${API}/public/leads`, { slug, ...form, params });
    fireConversion(data.tracking, data.tracking?.lead_label);
  };
  const onWhatsApp = () => {
    fireConversion(data.tracking, data.tracking?.whatsapp_label);
    axios.post(`${API}/public/events`, { slug, type: "whatsapp_click", params }).catch(() => {});
  };
  const onCall = () => {
    fireConversion(data.tracking, data.tracking?.call_label);
    axios.post(`${API}/public/events`, { slug, type: "call_click", params }).catch(() => {});
  };
  return <LandingView data={data} onLead={onLead} onWhatsApp={onWhatsApp} onCall={onCall} />;
}
